import { Controller, useFormContext } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormControlProps } from '../types';

import { Fordelingssystem } from './components/fordelingssystem';
import { CheckboxArea } from './components/checkboxArea';

export const Fjernvarme: FC<AboutFormControlProps> = ({ control }) => {
  const { setValue } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name="oppvarmingSelection.oppvarmingFjernvarme"
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <CheckboxArea
          onChange={(checked: boolean) => {
            onChange(checked);
            if (!checked) {
              setValue(`oppvarming.oppvarmingFjernvarme`, undefined);
            }
          }}
          i18nPrefix="register.tekniskUtstyr.oppvarmingFjernvarme"
          value={!!value}
          error={error}
        >
          <Controller
            name="oppvarming.oppvarmingFjernvarme"
            control={control}
            rules={{
              validate: (value, formValues) => {
                // Require fjernvarme to be selected to validate field
                if (!formValues.oppvarmingSelection?.oppvarmingFjernvarme) {
                  return true;
                }

                if (value?.gulvvarme === undefined && value?.radiator === undefined) {
                  return t('register.tekniskUtstyr.oppvarmingFjernvarme.noSelection');
                }
                return true;
              }
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Fordelingssystem
                value={{
                  radiator: value?.radiator,
                  gulvvarme: value?.gulvvarme
                }}
                error={error}
                onChange={(fieldKey, val) =>
                  onChange({
                    ...value,
                    [fieldKey]: val
                  })
                }
              />
            )}
          />
        </CheckboxArea>
      )}
    />
  );
};
